<template>
  <div style="padding: 60px">
    <div v-if="status === true" align="center">
      <h1 >Activate Account</h1>
      <br/>
      <p>ยืนยันตัวตน ของผู้ใช้งาน: {{ this.username }}</p>
      <p><a href="#" @click.prevent="setPassword">คลิกที่นี่เพื่อตั้งรหัสผ่านของคุณ</a> และเสร็จสิ้นการยืนยันตัวตน</p>
    </div>
    <div v-if="status === false" align="center">
      <h1>Activate Not Found</h1>
    </div>
   
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      activate_token: null
    };
  },
  computed: {
    ...mapState({
      status: store => store.Login_store.activate,
      username: store => store.Login_store.activate_username
    })
  },
  mounted() {
    this.activate_token = this.$route.params.activate_token;
    this.type = this.$route.params.type;
    this.activate({ activate_token: this.activate_token, type: this.type });
  },
  methods: {
    ...mapActions({
      activate: "Login_store/activate"
    }),
    handlePage(status) {
      if(status){
        this.$confirm("ยืนยันเสร็จสิ้น ต้องการเข้าสู่ระบบ หรือไม่", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          cancelButtonText: "ยกเลิก",
          showCancelButton: true,
          type: "warning"
        })
          .then(() => {
            window.location = '/Login'
          })
          .catch(() => {});
      }
    },
    setPassword() {
      this.$router.push({ name: "Set_password", params: {activate_token: this.$route.params.activate_token} });
    }
  }
};
</script>

<style>
</style>